// import React from "react";
// import {
//   BottomNavigation,
//   BottomNavigationAction,
//   Paper
// } from "@mui/material";

// import HomeIcon from "@mui/icons-material/Home";
// import SearchIcon from "@mui/icons-material/Search";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import PersonIcon from "@mui/icons-material/Person";
// import LoginIcon from "@mui/icons-material/Login";
// import CallIcon from "@mui/icons-material/Call";

// import { useNavigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const MobileBottomNav = () => {
//   const isAuthenticated = useSelector(
//     (state) => state.user.isAuthenticated
//   );

//   const navigate = useNavigate();
//   const location = useLocation();

//   const go = (path) => {
//     if (path === "/") {
//       window.location.href = "/";
//     } else {
//       navigate(path);
//     }
//   };

//   // 🔥 active style helper
//   const actionStyle = (path) => ({
//     color: location.pathname === path ? "#1976d2" : "#757575",
//     "& .MuiBottomNavigationAction-label": {
//       color: location.pathname === path ? "#1976d2" : "#757575",
//       fontWeight: location.pathname === path ? 600 : 400
//     }
//   });

//   return (
//     <Paper
//       elevation={10}
//       sx={{
//         position: "fixed",
//         bottom: 0,
//         left: 0,
//         right: 0,
//         zIndex: 1300,
//         display: { xs: "block", md: "none" }
//       }}
//     >
//       <BottomNavigation
//         showLabels
//         sx={{
//           "& .MuiBottomNavigationAction-label": {
//             opacity: 1,
//             transform: "none",
//             fontSize: "12px"
//           }
//         }}
//       >
//         <BottomNavigationAction
//           label="Home"
//           icon={<HomeIcon />}
//           sx={actionStyle("/")}
//           onClick={() => go("/")}
//         />

//         <BottomNavigationAction
//           label="Search"
//           icon={<SearchIcon />}
//           sx={actionStyle("/search")}
//           onClick={() => go("/search")}
//         />

//         {!isAuthenticated && (
//           <>
//             <BottomNavigationAction
//               label="Contact"
//               icon={<CallIcon />}
//               sx={{
//                 ...actionStyle("/contact"),
//                 paddingBottom:"15px"
//               }}
//               onClick={() => go("/contact")}
//             />
//             <BottomNavigationAction
//               label="Sign In"
//               icon={<LoginIcon />}
//                sx={{
//                 ...actionStyle("/sign-up/login"),
//                 paddingBottom:"15px"
//               }}
             
//               onClick={() => go("/sign-up/login")}
//             />
//           </>
//         )}

//         {isAuthenticated && (
//           <>
//             <BottomNavigationAction
//               label="Saved"
//               icon={<FavoriteIcon />}
//               sx={{...actionStyle("/favorites"),
//                 paddingBottom:"15px"
//               }}
//               onClick={() => go("/favorites")}
//             />
//             <BottomNavigationAction
//               label="Profile"
//               icon={<PersonIcon />}
//               sx={{...actionStyle("/myprofile"),
//                 paddingBottom:"15px"
//               }}
//               onClick={() => go("/myprofile")}
//             />
//           </>
//         )}
//       </BottomNavigation>
//     </Paper>
//   );
// };

// export default MobileBottomNav;



import React ,{useState}from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper
} from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonIcon from "@mui/icons-material/Person";
import LoginIcon from "@mui/icons-material/Login";
import CallIcon from "@mui/icons-material/Call";
import MobileSearchDrawer from "../components/common/MobileSearchDrawer";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const MobileBottomNav = () => {
  const isAuthenticated = useSelector(
    (state) => state.user.isAuthenticated
  );

  const navigate = useNavigate();
  const location = useLocation();
  const [openSearch, setOpenSearch] = useState(false);

  const go = (path) => {
    if (path === "/") {
      window.location.href = "/";
    } else {
      navigate(path);
    }
  };

  //  active style helper
  const actionStyle = (path) => ({
    color: location.pathname === path ? "#1976d2" : "#757575",
    "& .MuiBottomNavigationAction-label": {
      color: location.pathname === path ? "#1976d2" : "#757575",
      fontWeight: location.pathname === path ? 600 : 400
    }
  });

  return (
    <Paper
      elevation={10}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        display: { xs: "block", md: "none" }
      }}
    >
      <BottomNavigation
        showLabels
        sx={{
          "& .MuiBottomNavigationAction-label": {
            opacity: 1,
            transform: "none",
            fontSize: "12px"
          }
        }}
      >
        <BottomNavigationAction
          label="Home"
          icon={<HomeIcon />}
          sx={actionStyle("/")}
          onClick={() => go("/")}
        />

      <BottomNavigationAction
            label="Search"
            icon={<SearchIcon />}
           onClick={() => navigate("/search")}

          />

        {!isAuthenticated && (
          <>
            <BottomNavigationAction
              label="Contact"
              icon={<CallIcon />}
              sx={{
                ...actionStyle("/contact"),
                paddingBottom:"15px"
              }}
              onClick={() => go("/contact")}
            />
            <BottomNavigationAction
              label="Sign In"
              icon={<LoginIcon />}
               sx={{
                ...actionStyle("/sign-up/login"),
                paddingBottom:"15px"
              }}
             
              onClick={() => go("/sign-up/login")}
            />
          </>
        )}

        {isAuthenticated && (
          <>
            <BottomNavigationAction
              label="Saved"
              icon={<FavoriteIcon />}
              sx={{...actionStyle("/favorites"),
                paddingBottom:"15px"
              }}
              onClick={() => go("/favorites")}
            />
            <BottomNavigationAction
              label="Profile"
              icon={<PersonIcon />}
              sx={{...actionStyle("/myprofile"),
                paddingBottom:"15px"
              }}
              onClick={() => go("/myprofile")}
            />
          </>

          
        )}
      </BottomNavigation>

    </Paper>
  );
};

export default MobileBottomNav;